import React from "react";
import { Flex, Heading } from "theme-ui";
import AppStoreBadge from "./app-store-badge";
import PlayStoreBadge from "./play-store-badge";

const DownloadAppCTA = () => {
  return (
    <Flex
      py={8}
      px={3}
      sx={{
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "primary",
      }}
    >
      <Heading as="h3" sx={{ textAlign: "center", color: "white" }}>
        Download the oneCoach app to watch tennis masterclasses anywhere, at
        anytime.
      </Heading>
      <Heading as="h5" sx={{ textAlign: "center", color: "white", my: 3 }}>
        Access 100+ video lessons & drills designed for all skill levels, from
        beginners to advanced players.
      </Heading>
      <Flex my={3}>
        <AppStoreBadge eventSuffix="all_programs" />
        <PlayStoreBadge eventSuffix="all_programs" />
      </Flex>
    </Flex>
  );
};

export default DownloadAppCTA;
